const excludeSupplierRoutes = (url) => {
  if (
    url === "company-details" ||
    url === "contact-details" ||
    url === "scope-of-supply" ||
    url === "certificates" ||
    url === "banking" ||
    url === "supplier-preview" ||
    url === "supplier-approval" ||
    url === "user-account"
  ) {
    return true;
  } else {
    return false;
  }
};

const getURLFromURL = (url) => {
  if (url === "material-preview") {
    return "material-request";
  } else if (url === "po-preview") {
    return "po-landing";
  } else if (url === "invoice-preview") {
    return "invoices";
  } else if (url === "viewMstLog") {
    return "manage-master-data";
  } else if (url === "report-details") {
    return "myreports";
  } else if (
    url === "bid-create" ||
    url === "bid-view" ||
    url === "bid-evaluate-response" ||
    url === "bid-response-linescore" ||
    url === "bid-tech-linescore" ||
    url === "bid-tech-score" ||
    url === "bid-comm-score" ||
    url === "bid-compare-responses" ||
    url === "bid-award-details"
  ) {
    return "quotation-evaluation";
  } else if (
    url === "bid-supplierView" ||
    url === "bid-response" ||
    url === "bid-response-view"
  ) {
    return "supplierBids";
  } else if (
    url === "account" ||
    url === "my-tasks" ||
    url === "notification-detail" ||
    url === "feedback"
  ) {
    return "dashboard";
  } else {
    return url;
  }
};

const setActiveMenu = (url) => {
  if (url === "supplier-approval") {
    return "supplier";
  } else if (url === "material-preview") {
    return "material-request";
  } else if (url === "po-preview") {
    return "po-landing";
  } else if (url === "invoice-preview") {
    return "invoices";
  } else if (url === "master-data-detail") {
    return "manage-master-data";
  } else if (url === "report-details") {
    return "myreports";
  } else if (
    url === "bid-create" ||
    url === "bid-view" ||
    url === "bid-evaluate-response" ||
    url === "bid-response-linescore" ||
    url === "bid-tech-linescore" ||
    url === "bid-tech-score" ||
    url === "bid-comm-score" ||
    url === "bid-compare-responses" ||
    url === "bid-award-details"
  ) {
    return "quotation-evaluation";
  } else if (
    url === "bid-supplierView" ||
    url === "bid-response" ||
    url === "bid-response-view"
  ) {
    return "supplierBids";
  } else if (
    url === "dashboard" ||
    url === "basic-settings" ||
    url === "lookup-parameters" ||
    url === "cost-centers" ||
    url === "approval-workflow" ||
    url === "setup-notification" ||
    url === "manage-master-data" ||
    url === "interface-monitor" ||
    url === "my-tasks" ||
    url === "emails" ||
    url === "user-profile" ||
    url === "profile" ||
    url === "notifications"
  ) {
    return url;
  } else if (url === "forbidden") {
    return;
  }
};

export { excludeSupplierRoutes, getURLFromURL, setActiveMenu };
